import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PartyApplicationFullTexts } from '../../types/PartyApplication/PartyApplicationTexts';

import {
  PartyApplicationState,
  ApplicationSteps,
  ApplicationType,
  ApplicantRole,
  UnionRole,
} from '../../types/PartyApplication/partyApplication';

const initialState: PartyApplicationState = {
  pageTexts: null,
  currentStep: ApplicationSteps.Form,
  applicationType: null,
  partyRegardingApplication: null,
  worksiteRegardingApplication: null,
  applicantRole: null,
  unionRole: null,
};

const partyApplicationSlice = createSlice({
  name: 'partyApplication',
  initialState,
  reducers: {
    setPageTexts: (state, action: PayloadAction<PartyApplicationFullTexts>) => {
      state.pageTexts = action.payload;
    },
    setCurrentStep: (state, action: PayloadAction<ApplicationSteps>) => {
      state.currentStep = action.payload;
    },
    setApplicationType: (state, action: PayloadAction<ApplicationType>) => {
      state.applicationType = action.payload;
    },
    setPartyRegardingApplication: (state, action: PayloadAction<string>) => {
      state.partyRegardingApplication = action.payload;
    },
    setWorksiteRegardingApplication: (state, action: PayloadAction<string>) => {
      state.worksiteRegardingApplication = action.payload;
    },
    setApplicantRole: (state, action: PayloadAction<ApplicantRole>) => {
      state.applicantRole = action.payload;
    },
    setUnionRole: (state, action: PayloadAction<UnionRole>) => {
      state.unionRole = action.payload;
    },
  },
});

export const {
  setPageTexts,
  setCurrentStep,
  setApplicationType,
  setPartyRegardingApplication,
  setWorksiteRegardingApplication,
  setApplicantRole,
  setUnionRole,
} = partyApplicationSlice.actions;

export default partyApplicationSlice.reducer;
